import type { ReactNode } from 'react';
import { create } from 'zustand';

interface SnackbarOptions {
  color?: 'success' | 'error' | 'info' | 'warning';
  title?: string;
  message?: string;
  icon?: ReactNode;
}

interface SnackbarState {
  isOpen: boolean;
  options: SnackbarOptions | undefined;

  actions: {
    openSnackbar: (options: SnackbarOptions) => void;
    closeSnackbar: () => void;
  };
}

export const useSnackbarStore = create<SnackbarState>()((set) => ({
  isOpen: false,
  options: undefined,

  actions: {
    openSnackbar: (options) => {
      set({ isOpen: true, options });
    },
    closeSnackbar: () => set({ isOpen: false, options: undefined }),
  },
}));
